import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Container } from '@mui/material';
import { theme } from '../styles/theme';

const Navbar = () => {
  return (
    <AppBar position="static" sx={{ bgcolor: 'white' }}>
      <Container maxWidth="lg">
        <Toolbar>
          <IconButton
            component={Link}
            to="/"
            sx={{ mr: 2 }}
            size="large"
          >
            <img
              src="/images/logo.png"
              alt="Yogi Plus Water Tank Logo"
              style={{
                height: '70px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </IconButton>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end'}}>
            <Button 
              component={Link} 
              to="/products"
              sx={{ color: theme.palette.primary.main, '&:hover': { bgcolor: 'transparent' } }}
            >
              Products
            </Button>
            <Button 
              component={Link} 
              to="/contact"
              sx={{ color: theme.palette.primary.main, '&:hover': { bgcolor: 'transparent' } }}
            >
              Contact Us
            </Button>
            <Button 
              component={Link} 
              to="/terms"
              sx={{ color: theme.palette.primary.main, '&:hover': { bgcolor: 'transparent' } }}
            >
              Terms & Conditions
            </Button>
            <Button 
              component={Link} 
              to="/shipping"
              sx={{ color: theme.palette.primary.main, '&:hover': { bgcolor: 'transparent' } }}
            >
              Shipping Policy
            </Button>
            <Button 
              component={Link} 
              to="/refund"
              sx={{ color: theme.palette.primary.main, '&:hover': { bgcolor: 'transparent' } }}
            >
              Refund Policy
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;